import React, { Suspense, lazy } from 'react';
import { Spin } from 'antd';
import { Switch, Route, useRouteMatch, useParams } from 'react-router-dom';

import { setBizCode } from '../services/business-details-service';

import withAdminLayout from '../layout/with-admin-layout';
import { useScrollPosition } from '../utilities/scroll-position-context';

const HomeDashboard = lazy(() => import('../pages/pg-home/pg-home'));
const Accounts = lazy(() => import('../pages/pg-accounts/pg-accounts'));
const AccountDetails = lazy(() => import('../pages/pg-accounts/pg-account-details/pg-account-details'));
const MyInvitees = lazy(() => import('../components/cp-accounts/cp-my-invitees/cp-my-invitees'));
const Teams = lazy(() => import('../pages/pg-teams/pg-teams'));
const TeamDetail = lazy(() => import('../pages/pg-teams/pg-team-details/pg-team-details'));
const Apps = lazy(() => import('../pages/pg-apps/pg-apps'));
const Activity = lazy(() => import('../pages/pg-activity/pg-activity'));
const Reports = lazy(() => import('../pages/pg-reports/pg-reports'));
const ResportDetails = lazy(() => import('../pages/pg-reports/pg-report-details/pg-resport-details'));
const Flows = lazy(() => import('../pages/pg-flows/pg-flows'));
const TxnCreate = lazy(() => import('../pages/pg-transaction/pg-txn-create'));
const ChangeBusiness = lazy(() => import('../pages/pg-change-business/pg-change-business'));
const BusinessProfile = lazy(() => import('../pages/pg-business-profile/pg-business-profile'));
const Maintenance = lazy(() => import('../pages/pg-maintenance/pg-maintenance'));
const transactionList = lazy(() => import('../pages/pg-myapp/pg-transactions/pg-transactions'));
const TxnEdit = lazy(() => import('../pages/pg-transaction/pg-txn-edit'));
const Insight = lazy(() => import('../pages/pg-insights/pg-insight'));
const TransactionsActivity = lazy(() =>
  import('../components/cp-transactions/cp-transactions-activity/cp-transactions-activity'),
);
const Tasks = lazy(() => import('../pages/pg-tasks/pg-tasks'));
const DataImport = lazy(() => import('../pages/pg-transaction/pg-txn-data-import'));
const PublicFormTxnCreate = lazy(() => import('../public-forms/dynamic-form/pg-txn-create'));

function Admin() {
  const { path } = useRouteMatch();
  const { bizCode } = useParams();
  const { restoreScrollPosition } = useScrollPosition();
  restoreScrollPosition();
  setBizCode(bizCode);

  return (
    <Suspense
      fallback={
        <div className="spin">
          <Spin />
        </div>
      }
    >
      <Switch>
        <Route exact path={`${path}/public/form/:formId`} component={PublicFormTxnCreate} />
        <Route exact path={`${path}/business/dashboard`} component={HomeDashboard} />
        <Route exact path={`${path}/teams`} component={Teams} />
        <Route exact path={`${path}/team/update/:teamId`} component={TeamDetail} />
        <Route exact path={`${path}/team/create`} component={TeamDetail} />
        <Route exact path={`${path}/accounts`} component={Accounts} />
        <Route exact path={`${path}/account/user/manage/:userId`} component={AccountDetails} />
        <Route exact path={`${path}/accounts/myinvites`} component={MyInvitees} />
        <Route exact path={`${path}/reports`} component={Reports} />
        <Route exact path={`${path}/reports/:reportId`} component={ResportDetails} />
        <Route exact path={`${path}/apps`} component={Apps} />
        <Route exact path={`${path}/activity`} component={Activity} />
        <Route exact path={`${path}/settings/DFC/flowList`} component={Flows} />
        <Route exact path={`${path}/services/txn/create/:serviceType/:perspectiveId`} component={TxnCreate} />
        <Route exact path={`${path}/service/activity/list/:serviceType`} component={TransactionsActivity} />
        <Route exact path={`${path}/profile/info`} component={ChangeBusiness} />
        <Route exact path={`${path}/account/profileinfo/:userAccountId`} component={BusinessProfile} />
        <Route exact path={`${path}/services/txn/edit/:txnId/:serviceType/:perspectiveId`} component={TxnEdit} />
        <Route exact path={`${path}/services/transactions/:svcType/:perspectiveId`} component={transactionList} />
        <Route exact path={`${path}/app/dashboards`} component={Insight} />
        <Route exact path={`${path}/tasks/taskslist`} component={Tasks} />
        <Route exact path={`${path}/import/data/list/:svcType/:perspectiveId`} component={DataImport} />
        <Route path="*" component={Maintenance} />
      </Switch>
      {/* <Route path={path} component={Dashboard} /> */}
    </Suspense>
  );
}

export default withAdminLayout(Admin);
